import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useFilterCarType } from "@tenant/cars";
import { CheckboxGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterCarType.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { type CarTypeFilter, CoreCarsComponent } from "~core-cars/types";

export type FilterCarTypeProps = {
  selectedValues: CarTypeFilter[];
  onChange: (values: CarTypeFilter[]) => void;
  options?: CarTypeFilter[];
} & PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.FilterCarType;
export const FilterCarType = (props: FilterCarTypeProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { className } = props;
  const { items, selectedValues, onChange } = useFilterCarType(props);

  return (
    <div className={clsx(block, className)}>
      <CheckboxGroup
        className={cn("checkbox-group")}
        options={items}
        checkedOptions={selectedValues}
        onOptionsChange={onChange}
      />
    </div>
  );
};
